<div fxLayout="column" fxLayoutGap="10px" style="padding-bottom: 5px;font-family: Roboto, Helvetica Neue, sans-serif;">
  <span>
    <mat-form-field>
      <input  matInput
              [matDatepicker]="picker"
              placeholder="sélectionner une date"
              matTooltip="Sélectionner une date"
              [(ngModel)]="date_filter">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </span>
  <div>
    <button color="accent" class="mat-button mat-small" mat-raised-button (click)="onValidate($event)" matTooltip="Filtrer" [disabled]="! date_filter" data-cy="btn-date-deposit-filtering">Filtrer</button>&nbsp;
  </div>

</div>
